<template>
  <div id="scoreLineDetail">
    <template v-if="$route.name === 'scoreLineDetail'">
      <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <el-form>
          <div class="mainCon" style="margin:0px;padding:24px 0px 0px 25px;">
            <div style="display:flex; flex-wrap: wrap;" class="scoreLineDetail">
              <el-form-item>
                  <div>考试批次：<font color="#006AFF">{{ formInfo.planName }}</font></div>
              </el-form-item>
              <el-form-item label="院校：">
                  <el-select v-model="formInfo.schoolId" placeholder="请选择" filterable @change="">
                      <el-option v-for="item in formInfo.schoolList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="教学点：">
                  <el-select v-model="formInfo.stationId" placeholder="请选择" filterable @change="">
                      <el-option v-for="item in formInfo.stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="关键词：">
                  <el-input v-model="formInfo.keyword" placeholder="姓名/准考证/证件号"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button type="primary" plain round @click="goSearch" style="margin-top: -3px;"> 查询 </el-button>
                  <el-button type="primary" plain round @click="goback" style="margin-top: -3px;"> 返回 </el-button>
              </el-form-item>
            </div>
          </div>
        </el-form>
        <div class="mainCon">
          <ots-table :tableHeader="tableHeader" :tableData="tableData" style="width:100%"></ots-table>
          <ots-pagination :pagination="pagination" @changeNum="changeSize" @changePage="changePage"></ots-pagination>
        </div>
    </template>
    <template v-else>
        <router-view></router-view>
    </template>
  </div>
</template>

<script>

import { getPlanApi,getScoreLinePassCountFn,exportScoreLinePassCountFn } from "@/http/modules/examSet/score";

export default {
  name: 'scoreLineDetail',
  data() {
    return {
      formInfo:{
        planName: '',
        schoolId: '',
        schoolList: [],
        stationId: '',
        stationList: [],
        keyword: '',
      },
      tableHeader:[
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "院校",
          prop: "schoolName",
        },
        {
          title: "教学点",
          prop: "stationName",
        },
        {
          title: "专业",
          prop: "subjectName",
        },
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "准考证号",
          prop: "entranceNo",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "学位外语课",
          prop: "groupCourseName4A",
        },
        {
          title: "学位外语课成绩",
          prop: "groupCourseScore4A",
        },
        {
          title: "学位专业课",
          prop: "groupCourseName4B",
        },
        {
          title: "学位专业课成绩",
          prop: "groupCourseScore4B",
        },
      ],
      mainTopBtnList: [
          {
              title: "导出",
              fn: this.exportInfo,
          },
      ],
      tableData: [],
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData(){
      getPlanApi({planId: this.$route.query.pId}).then((res) => {
        if (res.code == 1) {
          this.formInfo.planName = res.data.name;
        }
      });

      this.mixin_getSelectSchool().then((data) => {
        let tmpSchoolList = [{ id: "", name: "全部" }, ...data];
        this.formInfo.schoolList = tmpSchoolList;
        this.formInfo.schoolId = "";
      });

      this.mixin_getSelectStation().then((data) => {
        let tmpStationList = [{ id: "", name: "全部" }, ...data];
        this.formInfo.stationList = tmpStationList;
        this.formInfo.stationId = "";
      });

      this.goSearch();
    },
    async goSearch(){
      let params = {
        reportId: this.$route.query.id,
        schoolId: this.formInfo.schoolId,
        stationId: this.formInfo.stationId,
        searchKey: this.formInfo.keyword,
        page: this.pagination.page,
        size: this.pagination.size
      }
      const { code,data } = await getScoreLinePassCountFn(params)
      if(code == 1){
        if(data.records && data.records.length > 0){
          this.tableData = data.records;
          this.pagination.total = data.total;
        }else{
          this.tableData = [];
          this.pagination.total = 0;
        }
      }
    },
    exportInfo(){
      let params = {
        reportId: this.$route.query.id,
        schoolId: this.formInfo.schoolId,
        stationId: this.formInfo.stationId,
        searchKey: this.formInfo.keyword,
      }
      exportScoreLinePassCountFn(params).then(res => {
        if(res.code == 1){
          window.open(res.data, '_blank');
        }
      })
    },
    /* *** 分页相关 *** */
    changeSize(num) {
        this.pagination.size=num
        this.goSearch()
    },

    /* *** 分页相关 *** */
    changePage(p) {
        this.pagination.page=p
        this.goSearch()
    },
    goback(){
      this.$router.push({
        name: "scoreLine",
        query:{
          id: this.$route.query.bId,
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
.scoreLineDetail /deep/ .el-form-item__content {
  display: flex;
}
.mainCon {
  .el-form-item{
    margin-right: 10px;
  }
  /deep/ .el-table td > .cell {
    text-align: center !important;
  }
}
</style>